import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react'

const IdleTimeout = ({showModal, handleTClose, reset}) => {
    const [maxTime, setMaxTime] = React.useState(10);

    React.useEffect(() => {
        var timerID = null;
        if(maxTime > 0){
            timerID = setInterval(tick, 1000);
        }
        else{
            reset();
        }

        return () => {
            clearInterval(timerID);
        }
    }, [maxTime])

    const tick = () => {
        setMaxTime(maxTime - 1);
    }

    return (
        <Modal open={showModal} size='tiny' onClose={handleTClose}>
            <Modal.Header>
                You have been Idle!
            </Modal.Header>

            <Modal.Content style={styles.content}>
                You will get Timed Out. Do You want to Stay?
                <Modal.Description>
                    <p>Time Remaining: <span style={styles.maxT}>{maxTime}</span></p>
                </Modal.Description>
            </Modal.Content>

            <Modal.Actions>
                <Button primary onClick={handleTClose}>
                    Stay
                </Button>
                <Button danger onClick={reset}>
                    Leave
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

const styles = {
    content: {
        color: 'black',
        fontSize: '15px'
    },
    maxT: {
        color: 'red',
        fontWeight: 'bold'
    }
}


export default IdleTimeout;
